export class User {
  userName: string;
  userId: string;
  roles: string[] = [];
}
